import React, { useState } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { firebaseAuth } from "../../components/firebase/auth";
import { useNavigate } from "react-router-dom";

import PlantEnumsSearchInput from "../../components/search/PlantEnumsSearchInput";
import CardsPlant from "../../components/ui/cards/CardsPlant";

import CircularProgress from "@mui/material/CircularProgress";
import { useDeviceState } from "../../components/utils/globalStates";

import "./Plants.css";

function PlantsMain() {
  const [user, loading, error] = useAuthState(firebaseAuth);
  const navigate = useNavigate();
  const deviceState = useDeviceState();

  const [plantEnums, setPlantEnums] = useState([]);
  const [searchLoading, setSearchLoading] = useState(true);

  return (
    <div className="PlantsTab">
      <div className="PlantsSearch">
        <PlantEnumsSearchInput
          saveToList={setPlantEnums}
          page={0}
          setLoading={setSearchLoading}
        />
      </div>
      {searchLoading ? (
        <div className="PlantsSearchLoading">
          <CircularProgress color="inherit" />
        </div>
      ) : (
        <div className="PlantsList">
          {plantEnums.map((plantEnum, index) => (
            <CardsPlant
              key={index}
              plantEnum={plantEnum}
              isSmall={deviceState.deviceWidth > 800}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default PlantsMain;
